import React, {memo, Suspense} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"
import connect from "./connect"

type LinkProps = {
    href?: string
    iconSrc: string | null
    iconAltText: string
    iconFixedHeight?: number
    iconFixedWidth?: number
    title: string | null
    description?: string
    chevronIconAltText: string
    textAlignment: string
    type: string
    linkType: string
    hideBadge?: boolean
    handleClick?: () => void
    siteUrl: string
    realm: string
    variant: string
    iconsVersionPath: string
    maskTitle?: boolean
    dataTestid?: string
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
}

export const BurgerQuickLink = memo(
    ({
        href,
        iconSrc,
        iconAltText,
        iconFixedHeight,
        iconFixedWidth,
        title,
        description,
        chevronIconAltText,
        textAlignment,
        type,
        linkType,
        hideBadge,
        handleClick,
        siteUrl,
        realm,
        variant,
        iconsVersionPath,
        maskTitle = false,
        dataTestid,
        templating,
    }: LinkProps) => {
        const TemplatedComponent = useTemplatedComponent(templating, MANIFEST)

        const props = {
            href,
            iconSrc,
            iconAltText,
            iconFixedHeight,
            iconFixedWidth,
            title,
            description,
            chevronIconAltText,
            textAlignment,
            type,
            linkType,
            hideBadge,
            handleClick,
            siteUrl,
            realm,
            variant,
            iconsVersionPath,
            maskTitle,
            dataTestid,
        }

        return (
            <Suspense>
                <TemplatedComponent {...props} />
            </Suspense>
        )
    },
)
BurgerQuickLink.displayName = "BurgerQuickLink"

export default connect(BurgerQuickLink)
